"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createSbHttpError = void 0;

var _isUndefined = _interopRequireDefault(require("lodash/isUndefined"));

var _errorFactory = require("./error-factory");

var _constants = require("./constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copy all standard properties of httpResponse
// See: https://developer.mozilla.org/en-US/docs/Web/API/Response
var propertyMap = {
  headers: 'headers',
  ok: 'ok',
  redirected: 'redirected',
  status: 'status',
  statusText: 'statusText',
  type: 'type',
  url: 'url',
  useFinalURL: 'useFinalURL'
};
/**
 * @desc
 * Creates a SbHttpError to describe HTTP error.
 *
 * @param  {Object} httpResponse A HTTP Reponse object.
 * @return {Object}              SbHttpError object.
 */

var createSbHttpError = function createSbHttpError(httpResponse) {
  var detail = {};

  if (httpResponse === undefined) {
    throw Error('createSbHttpError::argument "httpResponse" must be defined');
  }

  Object.keys(propertyMap).forEach(function (key) {
    var propertyName = propertyMap[key];

    if (!(0, _isUndefined.default)(httpResponse[propertyName])) {
      detail[key] = httpResponse[propertyName];
    }
  });
  var message = httpResponse.statusText || _constants.SB_HTTP_ERROR_DEFAULT_MESSAGE;
  return (0, _errorFactory.errorFactory)(_constants.SB_HTTP_ERROR, message, detail);
};

exports.createSbHttpError = createSbHttpError;
//# sourceMappingURL=create-sb-http-error.js.map